import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';

import { Accessible } from '../../../../shared/mixins/accessible.mixin';
import { LiquidViewerMainContent } from '../../../liquid-viewer.models';

@Component({
    selector: 'meta-liquid-info',
    templateUrl: './liquid-info.component.html',
    styleUrls: ['./liquid-info.component.css'],
})
export class LiquidInfoComponent extends Accessible {

    @Output() doClose = new EventEmitter();

    override verticalNavSelector = 'button, input[type="radio"]:checked';
    override horizontalNavSelector = 'input[type="radio"]';

    $mainContent: InputSignal<LiquidViewerMainContent> = input.required({ alias: 'mainContent' });

    onClose(): void {
        this.doClose.emit();
    }
}
